module.exports = __webpack_public_path__ + "img/Trashcan.6f522dac.svg";